import { SystemStyleObject } from '@chakra-ui/react';

export const baseSx: SystemStyleObject = {
  py: [8, 12],
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderStyle: 'dashed',
  borderWidth: '1px',
  borderRadius: 'lg',
  borderColor: 'M.40',
  bg: 'M.20',
  outline: 'none',
  width: '100%',
  maxHeight: 'calc(100vh - 115px)',
  height: 476,
  overflow: 'auto',
  '@media screen and (max-height: 700px)': {
    marginTop: '90px',
  },
};

export const activeSx: SystemStyleObject = {
  borderColor: 'B.0',
};

export const acceptSx: SystemStyleObject = {
  borderColor: 'B.0',
};

export const rejectSx: SystemStyleObject = {
  borderColor: 'R.0',
};

export const closeBtnSx: SystemStyleObject = {
  position: 'absolute',
  top: 0,
  right: 0,
};
